import React from 'react';
import SolutionSealContainer from 'containers/SolutionSealContainer';

export default function SolutionSealPage() {
  return (
    <SolutionSealContainer />
  )
}
